import { Component, OnInit } from '@angular/core';
import { fetchUserAttributes, signInWithRedirect, signOut } from 'aws-amplify/auth';
import { ContractorService } from '@shared/services/contractor.service';
import { environment } from '@environments/environment';

@Component({
    // moduleId: module.id,
    selector: 'sidebar-cmp',
    templateUrl: 'sidebar.component.html',
    styleUrls: ['sidebar.component.scss'],
    standalone: false
})
export class SidebarComponent implements OnInit {
    userName: string;
    userEmail: string;
    public menuItems: any[];

    constructor(private contractorService: ContractorService) {}
   async ngOnInit() {
       await fetchUserAttributes().then( data => {
            this.userEmail = data.email;

            this.contractorService.getContractor(this.userEmail).subscribe(profile => {
                this.userName = profile['body']['cbmName']
            })
        } );
    }



    async onClickLogout() {
       await signOut()
        localStorage.clear();
    }
}
